// extracted by mini-css-extract-plugin
export var component = "Downloads-module--component--92e5e";
export var downloadItem = "Downloads-module--downloadItem--d3e85";
export var fadePop = "Downloads-module--fade-pop--681d7";
export var growHeightIn = "Downloads-module--grow-height-in--1f407";